import NotesList from './_NotesList';

export default NotesList;
